export default function last(array) {
  if (array) {
    return array[array.length - 1];
  }
}